<template>
  <v-layout row align-center justify-center class="wrap">
    <v-flex xs12 sm2>
      <date-picker
        customLabel="Start Date"
        :outlined="true"
        id="datePicker"
        :gt-date-string="'12-12-2010'"
      ></date-picker>
    </v-flex>
    <v-flex xs12 sm5>
      <destination-list-select @onSelect="onDestinationSelect($event)" :set-default="true" required></destination-list-select>
    </v-flex>
  </v-layout>
</template>

<script>
import DatePicker from "../gt/shared/DatePicker";
import DestinationListSelect from "../gt/shared/DestinationListSelect";

export default {
  name: "Playground",
  components: {
    DatePicker,
    DestinationListSelect
  }
};
</script>
<style scoped>
.wrap {
  background: linear-gradient(to right top, #1867c0, #19e5f4);
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/Playground.vue